"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualStream = void 0;
const stringify = require("json-stringify-safe");
const stream_1 = require("stream");
const ContextUtils_1 = require("./ContextUtils");
const AsyncLocalStorageRecords_1 = require("./AsyncLocalStorageRecords");
class ContextualStream extends stream_1.Writable {
    constructor(stream = process.stdout) {
        super();
        this.stream = stream;
    }
    write(chunk) {
        return this.stream.write(`${stringify(Object.assign(Object.assign(Object.assign({}, ContextUtils_1.contextUtils.getAdditionalLogAttributes()), { "X-Request-Id": AsyncLocalStorageRecords_1.asyncLocalStorageRecords.requestId, "X-Request-Caller": AsyncLocalStorageRecords_1.asyncLocalStorageRecords.requestCaller, "X-Request-Name": AsyncLocalStorageRecords_1.asyncLocalStorageRecords.requestName, "X-System-Trace-Ids": AsyncLocalStorageRecords_1.asyncLocalStorageRecords.traceId }), chunk))}\n`);
    }
}
exports.ContextualStream = ContextualStream;
//# sourceMappingURL=ContextualStream.js.map